<div class="dialog-container">
  <div class="dialog-header">
    <div class="header-content">
      <div class="icon-container">
        <lucide-icon name="notepad-text" class="header-icon" [size]="24"></lucide-icon>
      </div>
      <div class="header-text">
        <h2 class="dialog-title">
          {{ 'userManagementPage.auditLogsPage.auditLogEventDetailsDialog.title' | labelsProvider }}
        </h2>
        <p class="dialog-subtitle">{{ data.timestamp | date: 'MMM d, y HH:mm' }}</p>
      </div>
    </div>
    <button mat-icon-button mat-dialog-close class="close-button" [disableRipple]="true">
      <lucide-icon name="x" class="close-icon" [size]="24"></lucide-icon>
    </button>
  </div>

  <div class="summary-section">
    <div class="summary-item">
      <span class="summary-label">{{
        'userManagementPage.auditLogsPage.auditLogEventDetailsDialog.summary.objectType' | labelsProvider
      }}</span>
      <div class="summary-value">
        <lucide-icon [name]="getObjectTypeIcon(data.entityType)" class="summary-icon" [size]="16"></lucide-icon>
        <span>{{ formatEntityType(data.entityType) }}</span>
      </div>
    </div>
    <span class="summary-divider" aria-hidden="true"></span>
    <div class="summary-item">
      <span class="summary-label">{{
        'userManagementPage.auditLogsPage.auditLogEventDetailsDialog.summary.action' | labelsProvider
      }}</span>
      <span class="summary-value">{{ formatEntityAction(data.entityAction) }}</span>
    </div>
    <span class="summary-divider" aria-hidden="true"></span>
    <div class="summary-item">
      <span class="summary-label">{{
        'userManagementPage.auditLogsPage.auditLogEventDetailsDialog.summary.actorEmail' | labelsProvider
      }}</span>
      <span class="summary-value">{{ data.actor.email }}</span>
    </div>
  </div>

  <div mat-dialog-content class="dialog-content">
    @if (data.metadata) {
      <!-- Parent ID/Type metadata rows (shown first) -->
      @if (getMetadataBeforeEntityId(); as beforeMeta) {
        <div class="content-text" [innerHTML]="formatMetadata(beforeMeta)"></div>
      }

      <!-- Entity ID row with special handling (shown in middle after Parent Type) -->
      @if (data.metadata.entity_id) {
        <div class="metadata-row entity-id-row">
          <span class="metadata-key">{{
            'userManagementPage.auditLogsPage.auditLogEventDetailsDialog.entityId' | labelsProvider
          }}</span>
          <div class="metadata-value entity-id-value">
            @if (isEntityIdLinkable()) {
              <a
                class="entity-id-link"
                [href]="getEntityIdUrl()"
                target="_blank"
                rel="noopener noreferrer"
                [matTooltip]="data.metadata.entity_id"
                matTooltipClass="tooltip-container"
              >
                <span class="entity-id-text">{{ truncateEntityId(data.metadata.entity_id!) }}</span>
                <lucide-icon name="external-link" class="external-link-icon" [size]="14"></lucide-icon>
              </a>
            } @else {
              <span class="entity-id-text" [matTooltip]="data.metadata.entity_id" matTooltipClass="tooltip-container">
                {{ truncateEntityId(data.metadata.entity_id!) }}
              </span>
            }
            <app-copy-button
              [value]="data.metadata.entity_id!"
              [withCopyIcon]="true"
              [fixedSize]="true"
              class="copy-button-s"
            ></app-copy-button>
          </div>
        </div>
      }

      <!-- Remaining metadata rows (shown after Entity ID) -->
      @if (getMetadataAfterEntityId(); as afterMeta) {
        <div class="content-text" [innerHTML]="formatMetadata(afterMeta)"></div>
      }
    }
  </div>

  <div class="dialog-actions">
    <button mat-raised-button color="primary" mat-dialog-close class="close-button-primary" [disableRipple]="true">
      {{ 'userManagementPage.auditLogsPage.auditLogEventDetailsDialog.close' | labelsProvider }}
    </button>
  </div>
</div>
